import { css } from '@emotion/css';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Route, useLocation } from 'react-router-dom';
import { RootState } from '../../features';
import { actions } from '../../features/dream';
import { Loading } from '../shared/Loading';
import { LoadingFailed } from '../shared/LoadingFailed';
import { DialogRoute } from '../shared/routes/DialogRoute';
import { TitleHeader } from '../shared/TitleHeader';
import { DeleteSucceededDialog } from './detail/DeleteSucceededDialog';
import { DreamHistoryDetailDialog } from './detail/DreamHistoryDetailDialog';
import { MyIslandDreamDetailDialog } from './detail/MyIslandDreamDetailDialog';
import { DreamHistoryList } from './DreamHistoryList';
import { MyIslandDream } from './MyIslandDream';
import { DreamHistoryReportCompleteDialog } from './report/DreamHistoryReportCompleteDialog';
import { DreamHistoryReportForm } from './report/DreamHistoryReportForm';
import { OptionalDeleteDialog } from './report/OptionalDeleteDialog';

const Dream: React.FC = () => {
  const { t } = useTranslation('dream');
  const location = useLocation();
  const { history: historyState } = useSelector((state: RootState) => state.dream);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getLandHistories());
  }, [dispatch]);

  return (
    <>
      <main
        className={css`
          display: flex;
          flex-direction: column;
          width: 100%;
          height: 100%;
          .body {
            flex: 1 1 auto;
            overflow-x: hidden;
            overflow-y: scroll;
            pointer-events: ${location.pathname !== '/players/dream/history' ? 'none' : 'inherit'};
          }
          .loading {
            padding: 40px 0;
          }
        `}
      >
        <TitleHeader
          title={t('top')}
          backLabel={t('aria_button_back_to_passport')}
          color="#b4e4b5"
        />
        <div className="body">
          {(() => {
            switch (historyState.state) {
              case 'pending':
                return (
                  <div className="loading">
                    <Loading />
                  </div>
                );
              case 'error':
                return <LoadingFailed />;
              case 'ok':
                const { dreamLand, histories: items } = historyState.result;
                return (
                  <>
                    <MyIslandDream dreamLand={dreamLand} />
                    <DreamHistoryList items={items} />
                  </>
                );
            }
          })()}
        </div>
      </main>
      <DialogRoute path="/players/dream/history/delete-succeeded">
        <DeleteSucceededDialog />
      </DialogRoute>
      <Route path="/players/dream/history/report/:address">
        <DreamHistoryReportForm />
      </Route>
      <DialogRoute path="/players/dream/history/report-completed/:address">
        <DreamHistoryReportCompleteDialog />
      </DialogRoute>
      <DialogRoute path="/players/dream/history/optional-delete/:address">
        <OptionalDeleteDialog />
      </DialogRoute>
      <DialogRoute path="/players/dream/history/my-island-detail">
        <MyIslandDreamDetailDialog />
      </DialogRoute>
      <DialogRoute path="/players/dream/history/detail/:address">
        <DreamHistoryDetailDialog />
      </DialogRoute>
    </>
  );
};

export default Dream;
